/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import Autosuggest from "react-autosuggest";
import filter from "lodash/filter";

import iconsList from "../../../assets/fa5/fa5IconsList";

class IconPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minimizePlaceholder: false,
		};
	}

	onFocus = () => {
		this.setState({
			minimizePlaceholder: true,
		});
	};

	setField = value => {
		const { fieldApi } = this.props;
		const { setValue, setError } = fieldApi;
		setValue({
			...value,
		});
		setError("");
	};

	componentDidUpdate(prevProps) {
		const prevVal = prevProps.fieldState.value;
		const currentVal = this.props.fieldState.value;
		const prevIconName = prevVal ? prevVal.iconName : "";
		const currentIconName = currentVal ? currentVal.iconName : "";
		const currentIcon = iconsList[currentIconName];
		//when an icon is set we set the default weight
		//to the first item in the weights array
		if (prevIconName !== currentIconName && currentIcon && currentIcon.weights) {
			this.setField({
				...currentVal,
				weight: currentIcon.weights[0],
			});
		}
	}

	onTextChange = (event, { newValue }) => {
		const { fieldApi } = this.props;
		const { value } = fieldApi;
		const { setValue } = fieldApi;
		setValue({
			...value,
			iconName: newValue,
		});
	};

	getSuggestionValue = suggestion => {
		return suggestion.id;
	};

	renderSuggestion = suggestion => (
		<span>
			<i className={`${this.weightMapper(suggestion.weights[0])} fa-${suggestion.id}`}></i>&nbsp;
			{suggestion.id}
		</span>
	);

	onBlur = () => {
		const { fieldApi, fieldState, isRequired } = this.props;
		const { value } = fieldState;
		const iconName = value ? value.iconName : "";
		const currentIcon = iconsList[iconName];
		const { setError } = fieldApi;
		if (iconName.length < 1 && isRequired) {
			this.setState(
				{
					minimizePlaceholder: false,
				},
				setError("This field is required. Please select an icon.")
			);
		}
		//ensuring that the user typed a valid icon name
		else if (!currentIcon && iconName.length > 0) {
			setError("Please pick a valid icon name");
		} else {
			setError("");
		}
	};

	onWeightChange = e => {
		const { value } = e.target;
		const { fieldApi, fieldState } = this.props;
		const { setValue } = fieldApi;
		const currentValue = fieldState.value;
		setValue({
			...currentValue,
			weight: value,
		});
	};

	weightMapper = weight => {
		let prefix = "";
		switch (weight) {
			case "solid":
				prefix = "fas";
				break;
			case "regular":
				prefix = "far";
				break;
			case "light":
				prefix = "fal";
				break;
			case "brands":
				prefix = "fab";
				break;
			default:
				prefix = "fa";
				break;
		}
		return prefix;
	};

	render() {
		const { minimizePlaceholder } = this.state;
		const { fieldState, isRequired, placeholder, helperText } = this.props;
		const { value, error } = fieldState;
		const iconName = value && value.iconName ? value.iconName : "";
		const weight = value ? value.weight : "";
		const currentIcon = iconsList[iconName];

		const suggestions = filter(iconsList, icon => {
			return icon.id.includes(iconName.toLowerCase());
		});
		const isFocused = minimizePlaceholder ? "focus" : "";
		const hasError = error ? "has-error" : "";
		return (
			<div className={`fa5-icon-picker input-wrap ${isFocused} ${hasError}`}>
				<div className="row" onBlur={this.onBlur} onFocus={this.onFocus}>
					<div className="col-xs-5 input-box">
						<div className="placeholder">
							<span className={minimizePlaceholder ? "caption-text" : ""}>
								{isRequired && <span className="isrequired-label">*</span>}
								{placeholder}
							</span>
						</div>
						<Autosuggest
							suggestions={suggestions}
							onSuggestionsFetchRequested={() => {}}
							onSuggestionsClearRequested={() => {}}
							getSuggestionValue={this.getSuggestionValue}
							renderSuggestion={this.renderSuggestion}
							inputProps={{
								onChange: this.onTextChange,
								value: iconName,
							}}
						/>
					</div>
					<div className="col-xs-5 select-wrap">
						<div className="select-box">
							<div className="placeholder">
								<span className={minimizePlaceholder ? "caption-text" : ""}>weight</span>
							</div>
							<div className="select-arrow">
								<i className="fal fa-chevron-down"></i>
							</div>
							<select onChange={this.onWeightChange}>
								{currentIcon &&
									currentIcon.weights.map((weight, index) => {
										return (
											<option key={weight} value={weight} selected={index === 0}>
												{weight}
											</option>
										);
									})}
							</select>
						</div>
					</div>
					<div className="col-xs-2 preview-box">
						{currentIcon && <i className={`${this.weightMapper(weight)} fa-${currentIcon.id}`}></i>}
						{!currentIcon && <i className="fa fa-square"></i>}
					</div>
				</div>
				<div className="messages row no-gutter">
					<div className="col-xs-6">
						<div className="caption-text helper-message">{helperText}</div>
					</div>
					<div className="col-xs-6">
						{error ? <div className="error-message caption-text">{error}</div> : null}
					</div>
				</div>
			</div>
		);
	}
}

IconPicker.propTypes = {
	fieldApi: PropTypes.object,
	fieldState: PropTypes.object,
	helperText: PropTypes.string,
	placeholder: PropTypes.string,
	errorMessage: PropTypes.string,
	isRequired: PropTypes.bool,
};

const Wrapper = asField(({ fieldState, ...props }) => <IconPicker fieldState={fieldState} {...props} />);

export default Wrapper;
